import { render, staticRenderFns } from "./RealmGame.vue?vue&type=template&id=3f36826b"
import script from "./RealmGame.vue?vue&type=script&lang=js"
export * from "./RealmGame.vue?vue&type=script&lang=js"
import style0 from "./RealmGame.vue?vue&type=style&index=0&id=3f36826b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports